import { FieldType, Model, Schema } from "@core/index";

export interface ICaptcha {
    captchaId?: string;
    image?: string;
    audioUrl?: string;
    text?: string;
}

export class Captcha extends Model implements ICaptcha {
    public static schema: Schema = new Schema("CheckinInfoRequest");
    public captchaId?: string;
    public image?: string;
    public audioUrl?: string;
    public text?: string;

    constructor(values: ICaptcha) {
        super(Captcha.schema);
        this.setValues(values);
    }
}

Captcha.schema.addField("text").type(FieldType.String).required().maxLength(5);